import SlideshowPlayer from "../components/SlideshowPlayer";
export default function JournalPlayerPage() {
  return <SlideshowPlayer source="private" />;
}
